<template>
    <l-layout>
      <v-card class="pa-3">
        <v-layout column>
          <v-flex xs12>
            <l-autocomplete
              label="补卡用户"
              :get-data="findPerson"
              item-text="name"
              item-sub-text="loginId"
              prepend-icon="$vuetify.icons.person"
              v-model="form.code"
            ></l-autocomplete>
          </v-flex>
          <v-flex>
            <l-select-date label="补卡日期" v-model="form.date"></l-select-date>
          </v-flex>
        </v-layout>
        <v-layout justify-center>
          <v-btn class="primary" @click="submit" :loading="loading">提交</v-btn>
        </v-layout>
      </v-card>
    </l-layout>
</template>

<script>
    import LSelectDate from "../../../ladmin/components/LSelectDate/LSelectDate";
    export default {
        name: "record",
      components: {LSelectDate},
      data(){
          return {
            form:{
              date:'',
              code:''
            },
            loading:false,
            disabledFlag:false
          }
      },
      methods:{
        async findPerson (val) {
          try {
            let {items} = await this.$store.dispatch('userAdmin/getUsers', {
              pagination: {page: 1, rowsPerPage: 100},
              search: {key: 'name', value: val},
            })
            return items
          }
          catch (e) {
            this.$L.alert('error', e.message)
            return []
          }
        },
        async submit(val){
          try {
            this.loading = true
            //console.log(this.form.code)
            let params = {
              code:this.form.code.loginId||'',
              date:this.form.date
            }
            let res = await this.$store.dispatch('school/addRecord',params)
            if(res.data.status === 1){
              this.$L.alert('success',{message:'补卡成功'})
            }else{
              this.$L.alert('error',{message:'补卡失败，原因:'+res.data.msg})
            }
          }catch (e) {
            this.$L.alert('error',{message:e.toString()})
          }finally {
            this.loading = false
          }
        }
      }
    }
</script>

<style scoped>

</style>
